module.exports = __webpack_public_path__ + "assets/img/4e4fb6e9c66e6cda6b80404f77e1bac3.svg";